import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingPageError = ({
  retry
}) => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest",
    children: /*#__PURE__*/_jsx(Button, {
      onClick: retry,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.notFoundPage.pleaseLoadAgain"
      })
    })
  });
};
export default LoadingPageError;